/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
var PB_ITEM_TYPE = require('../enums/pricebreakdown_item_type.enum');
var PB_ITEM_ATTRS = require('../enums/pricebreakdown_item_attribute.enum');
var insuranceCatalogue = require('../../modules/collections/insurance_catalogue.collection');
var insuranceCatalogueCollection;

module.exports = (function() {
    'use strict';

    var INSURANCES_PB_ITEM_TYPE_LIST = [
        PB_ITEM_TYPE.INSURANCE,
        PB_ITEM_TYPE.INSURANCE_IN_CART,
        PB_ITEM_TYPE.ASSISTANCE_INSURANCE,
        PB_ITEM_TYPE.REBOOKING_INSURANCE,
        PB_ITEM_TYPE.CANX_INSURANCE,
    ];
    var PASSENGERS_PB_ITEM_TYPE_LIST = [
        PB_ITEM_TYPE.ADULTS,
        PB_ITEM_TYPE.CHILDREN,
        PB_ITEM_TYPE.INFANTS,
    ];
    var FEE_PB_ITEM_TYPE_LIST = [
        PB_ITEM_TYPE.SERVICE_FEE,
        PB_ITEM_TYPE.CC_FEE,
        PB_ITEM_TYPE.DISCOUNT_FEE,
        PB_ITEM_TYPE.DYNPACK_DISCOUNT_FEE,
    ];
    var PRICE_TYPE_LIST = [
        PB_ITEM_ATTRS.ONE_PRICE,
        PB_ITEM_ATTRS.ALL_PRICE,
        PB_ITEM_ATTRS.ALL_PRICE_PROVIDER,
        PB_ITEM_ATTRS.FARE,
        PB_ITEM_ATTRS.PROVIDER_FARE,
        PB_ITEM_ATTRS.TAX,
    ];
    var priceBreakdownItemScheme = {
        id: '',
        conceptKey: '',
        conceptLabel: '',
        fare: 0,
        providerFare: 0,
        allPrice: 0,
        allPriceProvider: 0,
        onePrice: 0,
        quantity: 0,
        tax: 0,
        type: '',
        departureIata: '', // Temporal until I do subclass
        arrivalIata: '', // Temporal until I do subclass
        baggageApplicationLevel: '', // Temporal until I do subclass
    };

    return Odigeo.Model.extend({
        idAttribute: 'pbId',
        defaults: priceBreakdownItemScheme,

        parse: function(response) {
            this.pbId = response.type + response.conceptKey;

            return response;
        },

        isBaggageOrBaggageWeightItem: function() {
            return this.isMatchingType(PB_ITEM_TYPE.BAGGAGES) || this.isMatchingType(PB_ITEM_TYPE.BAGGAGES_WEIGHT);
        },

        isBaggageItem: function() {
            return this.isMatchingType(PB_ITEM_TYPE.BAGGAGES);
        },

        isInsuranceItem: function() {
            return this.matchTypeFromList(INSURANCES_PB_ITEM_TYPE_LIST);
        },

        isAdditionalAncillaryProduct: function() {
            return this.isMatchingType(PB_ITEM_TYPE.ADDITION);
        },

        isPreselectedInsuranceItem: function() {
            var insurance = this.getInsurance(this.get('id'));

            return this.isInsuranceItem() &&
                !Odigeo._.isEmpty(insurance) &&
                insurance.preselected;
        },

        isPassengerItem: function() {
            return this.matchTypeFromList(PASSENGERS_PB_ITEM_TYPE_LIST);
        },

        isFeeItem: function() {
            return this.matchTypeFromList(FEE_PB_ITEM_TYPE_LIST);
        },

        matchTypeFromList: function(list) {
            return Odigeo._.some(list, function(type) {
                return this.isMatchingType(type);
            }, this);
        },

        isProductItem: function() {
            return !(this.isPassengerItem() || this.isFeeItem());
        },

        isMatchingType: function(type) {
            return Odigeo.Utils.isMatch(this.attributes, {type: type});
        },

        isQuantifiable: function() {
            return !this.isEmpty() ||
                this.get(PB_ITEM_ATTRS.ALL_PRICE) > 0;
        },

        isEmpty: function() {
            return this.get(PB_ITEM_ATTRS.QUANTITY) === 0;
        },

        isEmptyInsuranceInCart: function() {
            return this.get(PB_ITEM_ATTRS.TYPE) === PB_ITEM_TYPE.INSURANCE_IN_CART &&
                this.get(PB_ITEM_ATTRS.ONE_PRICE) === 0;
        },

        isVisible: function() {
            return !(this.isEmpty() || this.isEmptyInsuranceInCart());
        },

        hasPrice: function(priceConcept) {
            return this.get(priceConcept) !== 0;
        },

        getPrice: function() {
            if (this.get(PB_ITEM_ATTRS.QUANTITY) === 0) {
                return 0;
            }

            return this.hasPrice(PB_ITEM_ATTRS.ALL_PRICE) ?
                this.get(PB_ITEM_ATTRS.ALL_PRICE) : this.get(PB_ITEM_ATTRS.ONE_PRICE);
        },

        getProviderPrice: function() {
            if (this.get(PB_ITEM_ATTRS.QUANTITY) === 0) {
                return 0;
            }

            return this.hasPrice(PB_ITEM_ATTRS.ALL_PRICE_PROVIDER) ?
                this.get(PB_ITEM_ATTRS.ALL_PRICE_PROVIDER) : this.get(PB_ITEM_ATTRS.ONE_PRICE_PROVIDER);
        },

        getFormattedPrice: function(priceType) {
            if (Odigeo._.contains(PRICE_TYPE_LIST, priceType)) {
                return Odigeo.Utils.formatCurrency(this.get(priceType));
            }
        },

        toJSON: function() {
            var json = Odigeo.Model.prototype.toJSON.call(this);
            insuranceCatalogueCollection = insuranceCatalogue.getInstance();

            return Odigeo._.extend(json, {
                isBaggageItem: this.isBaggageItem(),
                isPassengerItem: this.isPassengerItem(),
                isProductItem: this.isProductItem(),
                isInsuranceItem: this.isInsuranceItem(),
                isAdditionalAncillaryProduct: this.isAdditionalAncillaryProduct(),
                isPreselectedInsuranceItem: this.isPreselectedInsuranceItem(),
                onePriceFormatted: this.getFormattedPrice(PB_ITEM_ATTRS.ONE_PRICE),
                allPriceFormatted: this.getFormattedPrice(PB_ITEM_ATTRS.ALL_PRICE),
                allPriceProviderFormatted: this.getFormattedPrice(PB_ITEM_ATTRS.ALL_PRICE_PROVIDER),
                fareFormatted: this.getFormattedPrice(PB_ITEM_ATTRS.FARE),
                providerFareFormatted: this.getFormattedPrice(PB_ITEM_ATTRS.PROVIDER_FARE),
                taxFormatted: this.getFormattedPrice(PB_ITEM_ATTRS.TAX),
                hasFare: this.hasPrice(PB_ITEM_ATTRS.FARE),
                hasTax: this.hasPrice(PB_ITEM_ATTRS.TAX),
                isEmpty: this.isEmpty(),
                isVisible: this.isVisible(),
                isQuantifiable: this.isQuantifiable(),
            });
        },

        equalsTo: function(obj) {
            var fieldsToCompare = [PB_ITEM_ATTRS.CONCEPT_KEY, PB_ITEM_ATTRS.TYPE];

            if (this.matchTypeFromList([PB_ITEM_TYPE.BAGGAGES, PB_ITEM_TYPE.BAGGAGES_WEIGHT])) {
                fieldsToCompare.push(PB_ITEM_ATTRS.ONE_PRICE);
            }

            return Odigeo._.every(fieldsToCompare, function(currentKey) {
                return Odigeo._.has(obj, currentKey) &&
                    Odigeo._.isEqual(this.attributes[currentKey], obj[currentKey]);
            }, this);
        },

        getInsurances: function() {
            return insuranceCatalogueCollection.isLoaded() ? insuranceCatalogueCollection.getInsurances() : [];
        },

        getInsurance: function(id) {
            return Odigeo._.find(this.getInsurances(), function(insurance) {
                return id === insurance.policy;
            }) || {};
        },
    });
})();
